"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var RenrenBox = function RenrenBox(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/social/renren_box-renren-box" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "combined-shape-renren-box" + unique,
    xlinkHref: "#path-1-renren-box" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-renren-box" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4,3 L20,3 C20.5522847,3 21,3.44771525 21,4 L21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 Z M8.52873492,13.1080077 C8.24683103,14.2757735 7.40415459,15.2741521 6.35428359,15.9374303 C6.99961665,16.2912745 7.74037317,16.4928779 8.52830892,16.4928779 C9.31640442,16.4928779 10.0573207,16.291168 10.7027602,15.937164 C9.65310225,15.2738858 8.81063881,14.2756138 8.52873492,13.1080077 Z M11.9843473,9.03983743 C11.3079164,8.24183749 10.3601251,7.68090519 9.28325648,7.50012247 L9.28325648,10.3437627 L9.28346948,10.3437627 C9.28346948,12.3732151 10.3935659,14.1181012 11.9839746,14.8886243 C11.3157974,14.0996235 10.9121114,13.0795191 10.9121114,11.9646835 C10.9121114,10.8493153 11.3156376,9.82867842 11.9843473,9.03983743 M11.9843473,9.03983743 C12.653057,9.82867842 13.087894,10.8493153 13.087894,11.9646835 C13.087894,13.0796789 12.652844,14.0998365 11.9845071,14.8888905 C11.9843473,14.888784 11.9841876,14.8886775 11.9839746,14.8886243 C11.9841876,14.8888373 11.9843473,14.8890503 11.9845071,14.8892633 C13.569857,14.1217754 14.7094005,12.3859418 14.7171749,10.3652224 L14.7171749,7.50001597 C13.6401466,7.68079869 12.6609379,8.24167774 11.9843473,9.03983743 M16.2266441,10.3437787 L16.2268571,10.3437787 C16.2268571,12.3734441 17.3371665,14.1184899 18.9278946,14.8889065 C19.5961783,14.0998525 19.9999708,13.0796416 19.9999708,11.9646462 C19.9999708,9.72107676 18.3679741,7.85973365 16.2266441,7.50013845 L16.2266441,10.3437787 Z M15.4721012,13.1080077 C15.1901973,14.2757735 14.3475209,15.2741521 13.2976499,15.9374303 C13.9429829,16.2912745 14.6836862,16.4928779 15.471622,16.4928779 C16.2597707,16.4928779 17.000687,16.291168 17.6461265,15.937164 C16.5964685,15.2738858 15.7540051,14.2756138 15.4721012,13.1080077 M7.77382996,10.3652064 L7.77382996,7.5 C5.63223369,7.8593822 3.99997076,9.72088506 3.99997076,11.9646675 C3.99997076,13.0798226 4.40392296,14.1001933 5.07241964,14.8892473 C6.65776958,14.1217594 7.76600225,12.3859791 7.77382996,10.3652064",
    fill: "inherit",
    id: "path-1-renren-box" + unique
  }))));
};

RenrenBox.propTypes = propTypes;
var _default = RenrenBox;
exports["default"] = _default;